import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppStore } from 'src/data-store/app/app.store';
import { DeviceService } from 'src/services/device.service';
import { EWatchedResponseCodes } from 'src/util/constants';

/**
 * HTTP interceptor for 426 - outdated app
 * Based on headers:
 * X-Device-Type
 * X-App-Version
 */
export const nativeValidVersionInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  const deviceService = inject(DeviceService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === EWatchedResponseCodes.NATIVE_APP_OUTDATED && deviceService.isNativePlatform) {
        injector.get(AppStore).displayViewNeedUpdateOverlay(true);
      }
      return next(req);
    })
  );
};
